<template>
	<div class="content">
		<div class="section">
			<div class="section-tit">작업검색</div>
			<div class="search-top">
				<div class="left">
					<label class="input-label">작업상태</label>
					<label class="input-checkbox">
						<input type="radio" name="radio1" v-model="searchInfo.st" :value="''" @change="getItemList(1)" />
						<span class="checkbox radio"></span>
						<span class="text">전체</span>
					</label>
					<label class="input-checkbox">
						<input type="radio" name="radio1" v-model="searchInfo.st" :value="'Y'" @change="getItemList(1)" />
						<span class="checkbox radio"></span>
						<span class="text">작업중</span>
					</label>
					<label class="input-checkbox">
						<input type="radio" name="radio1" v-model="searchInfo.st" :value="'N'" @change="getItemList(1)" />
						<span class="checkbox radio"></span>
						<!-- G-2: F-6 과 일관된 명명 — '작업종료' → '작업가능' (14일 경과 = 다른 직원이 맡을 수 있음) -->
						<span class="text">작업가능</span>
					</label>
					<label class="input-label">물건명</label>
					<input class="form-control sm" type="text" v-model="searchInfo.bName" @keyup.enter="getItemList(1)" />
					<label class="input-label">주소</label>
					<input class="form-control sm" type="text" v-model="searchInfo.addr" @keyup.enter="getItemList(1)" />

					<!-- G-2 / F-6.5: 담당자별 필터 — 작업중/작업가능 탭 모두에 적용.
					     백엔드 SP_WORKING / SP_R_WORKING 는 F-6.4 마이그레이션에서 mid 파라미터 지원. -->
					<label class="input-label">작업자</label>
					<select v-model="searchInfo.mid" class="form-control select sm" @change="getItemList(1)">
						<option :value="''">전체</option>
						<option v-for="c in memList" :key="'w_m_' + c.mem_uid" :value="c.mem_uid">
							{{ c.mem_name }} {{ c.mem_rank_name }}
						</option>
					</select>
				</div>
				<div class="right">
					<button type="button" class="btn btn-primary" @click="getItemList(1)">검색</button>
				</div>
			</div>
		</div>
		<div class="section">
			<div class="section-tit">
				작업목록
				<span class="sub">검색결과 : {{ totalCount }}건</span>
			</div>
			<div class="table-wrap">
				<table class="table click">
					<tr>
						<th>상태</th>
						<th>물건번호</th>
						<th>물건명</th>
						<th>주소</th>
						<th>용도지역</th>
						<th>대지(평)</th>
						<th>연면적(평)</th>
						<th>매매가(만)</th>
						<th>보증금</th>
						<th>월임대료</th>
						<th>연수익률</th>
						<th>작업자</th>
						<th>작업상태</th>
						<th>작업기한</th>
						<th>
							잔여일자
							<!-- G-2: 작업기한 남은 순 오름/내림 정렬 토글 — searchInfo.sort 는 'ASC'|'DESC'.
								ASC = 잔여일자 작은 순 (가장 임박한 기한 먼저) = sort-down 아이콘 (작은 값 위).
								DESC = 잔여일자 큰 순 = sort-down-alt 아이콘. 클릭할 때마다 토글 + 1 페이지 재조회. -->
							<button type="button" class="btn sort" @click="toggleSort" :title="searchInfo.sort === 'ASC' ? '잔여일자 오름차순' : '잔여일자 내림차순'">
								<b-icon-sort-down v-if="searchInfo.sort === 'ASC'" />
								<b-icon-sort-down-alt v-else />
							</button>
						</th>
					</tr>
					<tr v-for="item in itemList" :key="item.building_uid" @click="btnOnDetail(item.building_uid, isWorking(item))">
						<td>{{ $ITEM_STATE[item.sell_status] }}</td>
						<td>{{ item.building_uid }}</td>
						<td>{{ item.building_name }}</td>
						<td>{{ item.jibun_addr }}<br />{{ item.road_addr }}</td>
						<td>{{ item.use_area_name }}</td>
						<td>{{ $formatArea(item.land_size_p) }}</td>
						<td>{{ $formatArea(item.total_size_p) }}</td>
						<td>{{ $formatMoney(item.sell_price, $MONEY_FORMAT_TYPE.MUCH) }}</td>
						<td>{{ $formatMoney(item.ex_sum_rent_deposit, $MONEY_FORMAT_TYPE.LOAN) }}</td>
						<td>{{ $formatMoney(item.ex_sum_rent_money, $MONEY_FORMAT_TYPE.LOAN) }}</td>
						<td>{{ item.total_income_rate }}%</td>
						<td>{{ item.workinng_mem_name }}</td>
						<td>
							<span v-if="isWorking(item)" class="txt-c--red">작업중</span>
							<span v-else class="txt-c--blue">작업가능</span>
						</td>
						<td>{{ $dateFormat(item.sdate) }} ~ {{ $dateFormat(item.edate) }}</td>
						<td>{{ $dateSub(item.edate) }}</td>
					</tr>
				</table>
			</div>
			<ul class="pagination b-pagination pagination-sm" v-if="pageData != null && pageData.list.length">
				<li class="page-item" v-bind:class="{ disabled: 1 == page }">
					<button type="button" class="page-link" @click="getItemList(1)">
						<b-icon-chevron-double-left />
					</button>
				</li>

				<li class="page-item" v-bind:class="{ disabled: pageData.first == null }">
					<button type="button" class="page-link" @click="pageData.first !== null ? getItemList(pageData.first) : ''">
						<b-icon-chevron-left />
					</button>
				</li>
				<li
					v-for="pg in pageData.list"
					v-bind:key="'pg_' + pg"
					class="page-item"
					v-bind:class="{ active: pageData.currentPage == pg }"
				>
					<button type="button" class="page-link" @click="getItemList(pg)">{{ pg }}</button>
				</li>
				<li class="page-item" v-bind:class="{ disabled: pageData.end == null }">
					<button type="button" class="page-link" @click="pageData.end !== null ? getItemList(pageData.end) : ''">
						<b-icon-chevron-right />
					</button>
				</li>

				<li class="page-item" v-bind:class="{ disabled: pageData.totalPage == page }">
					<button type="button" class="page-link" @click="getItemList(pageData.totalPage)">
						<b-icon-chevron-double-right />
					</button>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WorkAdmin',
	components: {},
	data() {
		return {
			memList: [],
			itemList: [],

			searchInfo: {
				st: 'Y',
				bName: '',
				addr: '',
				mid: '',
				// G-2: 작업기한 정렬 방향 — 'ASC'(기본, 가장 임박한 기한 먼저) | 'DESC'.
				sort: 'ASC',
			},

			page: 1,
			pageData: null,
			totalCount: null,
			itemSize: 20,
			blockSize: 5,
		};
	},
	created() {
		// G-2 / F-6.5: 담당자 필터를 위한 mem list 로드
		this.getMemList();
		this.getItemList(1);
	},
	methods: {
		getMemList() {
			this.$apiGET('/admin/api/setting/etc/mem').then(data => {
				this.memList = data;
			});
		},
		getItemList(pg) {
			this.$apiGET(
				'/admin/api/working?page=' +
					(pg - 1) * this.itemSize +
					'&st=' +
					this.searchInfo.st +
					'&bName=' +
					this.searchInfo.bName +
					'&addr=' +
					this.searchInfo.addr +
					'&mid=' +
					this.searchInfo.mid +
					'&sort=' +
					this.searchInfo.sort,
			).then(data => {
				this.itemList = data.item;

				this.totalCount = data.pageInfo.totalCount;
				this.page = pg;
				this.pageData = this.$pageDataSetting(this.totalCount, this.itemSize, this.blockSize, this.page);
			});
		},
		// G-2: 잔여일자 헤더의 정렬 아이콘을 클릭해 ASC↔DESC 토글. 바로 1 페이지부터 재조회.
		toggleSort() {
			this.searchInfo.sort = this.searchInfo.sort === 'ASC' ? 'DESC' : 'ASC';
			this.getItemList(1);
		},
		isWorking(item) {
			// F-6.2 regression fix: item.edate may be an ISO UTC string (mysql
			// Date→JSON, e.g. "2026-04-14T15:00:00.000Z" for KST midnight
			// 2026-04-15) OR a plain "YYYY-MM-DD" string. String-slicing the ISO
			// form yields the UTC date, which is one calendar day behind KST —
			// a 작업중 row with edate=today was mislabeled as 작업가능. Running
			// edate through new Date() and re-extracting local components yields
			// the correct local YYYY-MM-DD regardless of wire format.
			if (!item.edate) return false;
			const ed = new Date(item.edate);
			if (isNaN(ed.getTime())) return false;
			const edStr = `${ed.getFullYear()}-${String(ed.getMonth() + 1).padStart(2, '0')}-${String(ed.getDate()).padStart(2, '0')}`;
			const now = new Date();
			const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
			return todayStr <= edStr;
		},
		btnOnDetail(cid, isWorking) {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			const target = isWorking ? '/MapDetail/' : '/MapWrite/';
			window.open(target + cid, '', attr);
		},
	},
};
</script>

<style></style>
